import { ButtonBase, Grid, SxProps, Theme } from "@mui/material";
import Text from "@/components/Text";
import { CHART_COLORS } from "@/components/app/provider/patient/chart";
import { EyeVisibilityIcon } from "@/components/svg-icons/material-icons";
import {
  APPOINTMENT_FORMS_TEXT,
  APPOINTMENT_FORM_LABEL_COLOR,
  APPOINTMENT_FORM_VALUE_COLOR,
} from "../appointment-additional-forms-constant";
import { AppointmentFormRow } from "../appointment-additional-forms-types";

export interface AppointmentFormRowItemProps {
  row: AppointmentFormRow;
  onView: (row: AppointmentFormRow) => void;
  sx?: SxProps<Theme>;
}

/** One form: its name, then "Preview Form" when submitted or a dash when not. */
const AppointmentFormRowItem = ({
  row,
  onView,
  sx,
}: AppointmentFormRowItemProps) => (
  <Grid container alignItems="center" sx={sx}>
    <Grid item xs={4.5}>
      <Text fontWeight="medium" color={APPOINTMENT_FORM_LABEL_COLOR}>
        {row.label}
      </Text>
    </Grid>
    <Grid item xs={0.3}>
      <Text color={APPOINTMENT_FORM_LABEL_COLOR}>:</Text>
    </Grid>
    <Grid item xs={7.2}>
      {row.isSubmitted ? (
        <ButtonBase
          onClick={() => onView(row)}
          aria-label={`${APPOINTMENT_FORMS_TEXT.previewForm} ${row.label}`}
          sx={{ gap: 1, borderRadius: 1 }}
        >
          <EyeVisibilityIcon
            fontSize="small"
            sx={{ color: CHART_COLORS.primary }}
          />
          <Text color={CHART_COLORS.primary}>
            {APPOINTMENT_FORMS_TEXT.previewForm}
          </Text>
        </ButtonBase>
      ) : (
        <Text color={APPOINTMENT_FORM_VALUE_COLOR}>
          {APPOINTMENT_FORMS_TEXT.placeholder}
        </Text>
      )}
    </Grid>
  </Grid>
);

export default AppointmentFormRowItem;
